import * as React from 'react'

import { cn } from './cn'

export interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical'
  flexItem?: boolean
  variant?: 'fullWidth' | 'inset' | 'middle'
  component?: React.ElementType
}

const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  (
    {
      orientation = 'horizontal',
      flexItem,
      variant = 'fullWidth',
      component: Component = 'hr',
      className,
      children,
      ...props
    },
    ref,
  ) => {
    if (children) {
      return (
        <div
          ref={ref}
          role="separator"
          className={cn(
            'flex items-center gap-3 text-sm text-text-secondary',
            'before:h-px before:grow before:bg-divider after:h-px after:grow after:bg-divider',
            className,
          )}
          {...props}
        >
          {children}
        </div>
      )
    }

    return (
      <Component
        ref={ref}
        className={cn(
          'border-0 bg-divider',
          orientation === 'vertical'
            ? cn('w-px', flexItem ? 'self-stretch' : 'h-full')
            : 'h-px w-full',
          variant === 'inset' && 'ml-10',
          variant === 'middle' && 'mx-4',
          className,
        )}
        {...props}
      />
    )
  },
)
Divider.displayName = 'Divider'

export default Divider
